import {Component, OnInit} from '@angular/core';
import {AbstractControl, FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import {ToastrService} from 'ngx-toastr';
import {UserService} from '../../services/user.service';
import {TokenStorageService} from '../../services/storage/token-storage.service';

@Component({
    selector: 'app-profile-page',
    templateUrl: './profile-page.component.html',
    styleUrls: ['./profile-page.component.css'],
    standalone: false
})
export class ProfilePageComponent implements OnInit {

  submitted: boolean = false;
  form: FormGroup = new FormGroup({
    fullName: new FormControl(''),
    email: new FormControl(''),
    contactNo: new FormControl(''),
    contactNumber: new FormControl(''),
    company: new FormControl(''),
    country: new FormControl(''),
    institution: new FormControl(''),
    username: new FormControl(''),
    region: new FormControl(''),
    openAPIEnabled : new FormControl(''),
    embedAPIEnabled : new FormControl(''),
    backOfficeAPIEnabled : new FormControl(''),
    dwmAPIEnabled : new FormControl(''),
    feedAPIEnabled : new FormControl('')
  });
  countryList: any[] = [];
  updating: boolean = false;
  loadingUserData = false;
  loadingCountryList = false;
  role: string = "";
  user: any;
  loadingInstitutionApiData = false;
  apis : any;

  institution: string="";
  showAdminComponents = false;
  showBrokerComponents = false;
  showBrokerAdminComponents = false;
  showInternalUserComponents = false;
  loggedInUserInstitution:string="";
  openAPIEnabled : any;
  embedAPIEnabled : any;
  backOfficeAPIEnabled : any;
  dwmAPIEnabled : any;
  feedAPIEnabled : any;
  allowedCountryCodes:any[]=[];


  constructor(private formBuilder: FormBuilder, private toastr: ToastrService, private tokenStorage: TokenStorageService, private userService: UserService) {
  }

  ngOnInit(): void {
    if (this.tokenStorage.getToken()) {
      this.user = this.tokenStorage.getUser()
      this.role = this.user.role;
      this.loggedInUserInstitution = this.user.institution;


      if (this.role === 'admin') {
        this.form.get('contactNo')?.disable();
      }
      this.showAdminComponents = this.tokenStorage.getUser().role == 'admin';
      this.showBrokerComponents = this.tokenStorage.getUser().role == 'broker';
      this.showBrokerAdminComponents = this.tokenStorage.getUser().role == 'brokerAdmin';
      this.showInternalUserComponents = this.tokenStorage.getUser().role == 'internalUser';

    }


    this.loadingUserData = true;
    this.userService.getLoggedInUserDetails(this.user.username).subscribe({
      next: (data) => {
        this.loadingUserData = false;
        if (data.status == 'SUCCESS') {
          this.user = data;
          this.initializeForm();
        } else {
          this.toastr.error(data.reason, 'Getting user details failed');
        }
      },
      error: (err) => {
        this.loadingUserData = false;
        this.toastr.error(err.error.message, 'Getting user details failed');
      }
    });

    this.loadingCountryList = true;
    this.userService.getCountryList().subscribe({
      next: (data) => {
        this.loadingCountryList = false;
        if (data.status == 'SUCCESS') {
          this.countryList = data.countryList;
          this.allowedCountryCodes = this.countryList.map((country: any) =>
            country.countryCode.toLowerCase()
          );
        } else {
          this.toastr.error(data.reason, 'Getting country list failed');
        }

      },
      error: (err) => {
        this.loadingCountryList = false;
        this.toastr.error(err.error.message, 'Getting country list failed');
      }
    });

  }


  initializeForm(): void {
    this.form = this.formBuilder.group(
      {
        fullName: [
          (this.user.firstName + ' ' + this.user.lastName),
          [
            Validators.required
          ]
        ],
        email: [
          (this.user.email),
            null
        ],
        contactNo: [
          (this.user.contactNo),
          null
        ],
        contactNumber: [
          (this.user.contactNo.split("-")[1]),
          null
        ],
        company: [
          (this.user.companyName),
          [
            Validators.required
          ]
        ],
        country: [
          (this.user.countryId),
          (this.role == 'admin') ? null : [Validators.required]
        ],
        username: [
          (this.user.username)
        ],
        institution: [
          (this.loggedInUserInstitution)
        ],
        region: [
          (this.user.region),
          [
            Validators.required
          ]
        ],

        openAPIEnabled: [{ value: this.user.openAPIEnabled, disabled: true }, [Validators.required]],
        embedAPIEnabled: [{ value: this.user.embedAPIEnabled, disabled: true }, [Validators.required]],
        backOfficeAPIEnabled: [{ value: this.user.backOfficeAPIEnabled, disabled: true }, [Validators.required]],
        dwmAPIEnabled: [{ value: this.user.dwmAPIEnabled, disabled: true }, [Validators.required]],
        feedAPIEnabled: [{ value: this.user.feedAPIEnabled, disabled: true }, [Validators.required]]
      }
    );
  }

  onClickSubmit() {
    this.submitted = true;
    var user_choice = window.confirm('Would you like to Save Changes?');
    if (!user_choice) {
      return;
    }
    if (this.form.invalid) {
      this.toastr.error('Please fill the form', 'Error');
      return;
    }
    const fullName = this.form.value.fullName.trim().split(/\s+/);
    const firstName = fullName[0];
    const lastName = fullName.slice(1).join(' '); // in case there's a middle name
    this.updating = true;
    const {
      email,
      contactNo,
      contactNumber,
      profession,
      company,
      country,
      username,
      region,
      openAPIEnabled,
      embedAPIEnabled,
      backOfficeAPIEnabled,
      dwmAPIEnabled,
      feedAPIEnabled
    } = this.form.value;
    this.userService.editProfileDetails(
      firstName,
      lastName,
      email,
      contactNo.dialCode + '-' + contactNumber,
      profession,
      company,
      country,
      username,
      this.user.institutionId,
      username,
      region,
      openAPIEnabled == true ? 1 : 0,
      embedAPIEnabled == true ? 1 : 0,
      backOfficeAPIEnabled == true ? 1 : 0,
      dwmAPIEnabled == true ? 1 : 0,
      feedAPIEnabled == true ? 1 : 0).subscribe({
      next: data => {
        this.updating = false;
        if (data.status == 'SUCCESS') {
          this.toastr.success('User updated successfully', 'Success');
          setTimeout(() => {
            this.reloadPage();
          }, 1000);
        } else {
          this.toastr.error(data.reason, 'User update failed');
        }
      },
      error: err => {
        this.updating = false;
        this.toastr.error(err.error.message, 'User update failed');
      }
    });
  }

  reloadPage(): void {
    window.location.reload();
  }

  get formControl(): { [key: string]: AbstractControl } {
    return this.form.controls;
  }


}
